import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/GoodsReceiveNoteReport/WarehouseReportGoodsReceiveAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseReportGoodsReceiveActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/GoodsReceiveNoteReport/WarehouseReportGoodsReceive")
	}

	render() {
		return (
			<Activity 
				name="WarehouseReportGoodsReceive"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseReportGoodsReceive"
				action="WarehouseReportGoodsReceive"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseReportGoodsReceiveActivity)
